import { render, staticRenderFns } from "./GenseeVideoPlayer.vue?vue&type=template&id=dbec1c9c&scoped=true&"
import script from "./GenseeVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./GenseeVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GenseeVideoPlayer.vue?vue&type=style&index=0&id=dbec1c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec1c9c",
  null
  
)

export default component.exports